export default {
  'profile.activationCode': 'Send Activation Code',
  'profile.codeSent': 'Activation Code sent. Please retrieve.',
  'profile.enterCode': 'Enter Code',
  'profile.helpText.email': '',
  'profile.helpText.sms':
    'This mobile phone number must be activated to receive passcodes via SMS. Clicking the Send Activation Code button will send an activation code to this phone.',
  'profile.helpText.voice': '',
  'profile.label.email': 'Email Address',
  'profile.label.ext': 'Extension',
  'profile.label.extDialDelay': 'Delay',
  'profile.label.sms': 'Text Message',
  'profile.label.voice': 'Voice Call',
  'profile.phoneNumber': 'Phone Number',
  'profile.security.subheader': 'For Passcode Delivery',
  'profile.securityInformation': 'Security Contact Information',
  'profile.securityTab': 'Security Contact',
  'profile.updated': 'User information updated',
  'profile.noDefaultError': 'For improved security, please update your default delivery channel'
};
